import { Rule } from './rule';

export class HiLoCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.hilo.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.hilo.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.hilo.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.hilo.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-2b' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-2c' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-2d' },
      ],
    },
    {
      title: 'components.cheat-sheet.hilo.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.hilo.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-3b' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-3c' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-3d' },
      ],
    },
    {
      title: 'components.cheat-sheet.hilo.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.hilo.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-4c' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-4d' },
      ],
    },
    {
      title: 'components.cheat-sheet.hilo.header-5',
      body: [
        { type: 'text', content: 'components.cheat-sheet.hilo.body-5a' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-5b' },
        { type: 'text', content: 'components.cheat-sheet.hilo.body-5c' },
      ],
    },
  ];
}
